import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page41() {
  useEffect(() => {
    document.title = "Маяк — Страница 40"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page39" />
        <ForwardLink href="/page41" />
      </div>

      <p style={{ textAlign: "right" }}>40.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Нет, сэр.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Хранишь секреты, да?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Нет, сэр.
      </p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>
        Мне бы не помешала помощь<br/>
        с досками.
      </p>
      <br/>
      <p>СНАРУЖИ. СИГНАЛЬНАЯ СТАНЦИЯ – ДЕНЬ</p>
      <p>МОЛОДОЙ заколачивает окна. СТАРИК помогает.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ЗА КАДРОМ)<br/>
        А теперь у меня сюрприз.
      </p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ. БЕРЕГ – ДЕНЬ</p>
      <p>
        МОЛОДОЙ неуверенно стоит на камне, тянет ВЕРЕВКУ<br/>
        из воды. СТАРИК наблюдает за ним.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Тащи, тащи, молодец. Тащи,<br/>
        Уинслоу!
      </p>
      <p>МОЛОДОЙ вытаскивает из воды деревянную ЛОВУШКУ ДЛЯ ОМАРОВ.</p>
      <p>МОЛОДОЙ УЛЫБАЕТСЯ. Как и СТАРИК.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        Только посмотри на них! Лучше, чем рыбачить<br/>
        на плавнике!
      </p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КАМБУЗ – НОЧЬ</p>
      <p>
        На тарелках свалены изувеченные РАКУШКИ ОМАРОВ. Судя<br/>
        по лицам МОЛОДОГО и СТАРИКА, еда была сытной.
      </p>
      <p>СТАРИК наливает две чашки грога (рома, разбавленного водой). Передает одну МОЛОДОМУ.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Сегодня опрокинуть кружку – не преступление.<br/>
        Ночка ясная.<br/>
        (ДАЛЕЕ)
      </p>
      <p style={{ textAlign: "right" }}>40.</p>

      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page39" />
        <ForwardLink href="/page41" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710314213/the-lighthouse-script/grlyj7zuyc8zo1lkvmar.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page41;
